/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from "@mui/material";
import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { tfidHighlightExtension } from "utils/TfidCodemirrorExtension";

const ResizableForm = ({ isOpen, onClose, onSubmit, columns, newRow, handleInputChange, renderCustomInput }: any) => {
  useEffect(() => {
    if (isOpen) {
      columns.forEach((column: any) => {
        if (newRow[column.key] === undefined && column.default !== undefined) {
          handleInputChange(column.key, column.default);
        }
      });
    }
  }, [isOpen, columns, newRow, handleInputChange]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        style: {
          resize: "both",
          overflow: "auto",
          minWidth: "400px",
          minHeight: "300px",
        },
      }}
    >
      <DialogTitle>Add New Entry</DialogTitle>
      <DialogContent>
        {columns.map((column: any) => (
          <div key={String(column.key)} style={{ marginTop: "16px" }}>
            {renderCustomInput && renderCustomInput(column.key, newRow[column.key], handleInputChange) ? (
              renderCustomInput(column.key, newRow[column.key], handleInputChange)
            ) : column.type === "string" ? (
              <TextField
                label={column.label}
                value={newRow[column.key] ?? ""}
                onChange={(e) => handleInputChange(column.key, e.target.value)}
                fullWidth
              />
            ) : column.type === "object" ? (
              <div>
                <label>{column.label}</label>
                <CodeMirror
                  value={newRow[column.key] ?? ""}
                  height="200px"
                  extensions={[json(), tfidHighlightExtension]}
                  onChange={(val) => handleInputChange(column.key, val)}
                />
              </div>
            ) : null}
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSubmit} variant="contained" color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResizableForm;
